import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a270b31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "phone-control-display-body" }
const _hoisted_2 = {
  key: 0,
  class: "header-information"
}
const _hoisted_3 = { class: "ml-1 mr-10" }
const _hoisted_4 = { class: "ml-auto" }
const _hoisted_5 = {
  key: 1,
  class: "conversation-history"
}
const _hoisted_6 = {
  key: 0,
  class: "message npc"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "message-text" }, "...", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "message-text" }
const _hoisted_11 = { class: "controls" }

import IconComponent from '../../../icon/IconComponent.vue';
import Icon from '@/components/icon/Icon';
import { DefinedComponent } from '@vue/test-utils/dist/types';
import { computed } from 'vue';
import { onUnmounted, toRef, ref } from 'vue';
import { PhoneLineComposable } from '../../../../ecs/phone/PhoneLine';
import TerminalControlComponent from './TerminalControlComponent.vue';
import OptionSelectComponent from './OptionSelectComponent.vue';
import OrderedCheckboxComponent from './OrderedCheckboxComponent.vue';
import { MessageBroadcast } from '../../../../models/BuildableDialogItem';
import { secondsToMinutesObject } from '../../../../utils/utils';
import { useRouter } from 'vue-router';
import { ControlType, sender } from '../../../../ecs/dialog/component';
import RadioControlComponent from './RadioControlComponent.vue';
import GiantVoiceControlComponent from './GiantVoiceControlComponent.vue';
import HushLineBodyWidget from './HushLineBodyWidget.vue';
type ControlMap = {
  [key in ControlType]: DefinedComponent;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneLineBodyWidget',
  props: {
    phoneLine: null
  },
  setup(__props: any) {

const props = __props as {
  phoneLine: PhoneLineComposable;
}

const router = useRouter();

const controls: ControlMap = {
  OptionSelect: OptionSelectComponent,
  Terminal: TerminalControlComponent,
  OrderedCheckbox: OrderedCheckboxComponent,
  Radio: RadioControlComponent,
  GiantVoice: GiantVoiceControlComponent,
  Hushline: HushLineBodyWidget
};
const TEN_SECONDS = 10000;
const control = computed(
  () => controls[playerBrain.value.brain.value.controlType]
);


const description = toRef(props.phoneLine, 'description');
const timeStarted = Date.now();
const timeOnActiveCall = ref(
  secondsToMinutesObject((Date.now() - timeStarted) / 1000)
);

const intervalHandle = setInterval(() => {
  timeOnActiveCall.value = secondsToMinutesObject(
    (Date.now() - timeStarted) / 1000
  );
}, 50);

function handleHangUp() {
  router.go(-1);
}

function handleToggleActiveState() {
  props.phoneLine.toggleActiveState(TEN_SECONDS);
}

function isPlayer(sender: sender) {
  return sender === 'player';
}

const playerBrain = toRef(props.phoneLine, 'brain');
const brainControlType = toRef(
  props.phoneLine.brain.brain.value,
  'controlType'
);

const showThinkingMessage = computed(() => {
  return (
    playerBrain.value.brain.value.history.length === 0 &&
    brainControlType.value === 'OptionSelect'
  );
});

function isBuildableDialogControlType(): boolean {
  return (
    brainControlType.value === 'GiantVoice' ||
    brainControlType.value === 'Radio'
  );
}

const showConversationHistory = () => {
  return (
    brainControlType.value === 'OptionSelect' ||
    brainControlType.value === 'Hushline'
  );
};

const handleOptionClicked = (payload: string) => {
  const messageBroadcast: MessageBroadcast<string> = {
    payload,
    messageType: 'Media Session'
  };
  props.phoneLine.sendMessage(messageBroadcast);
  if (isBuildableDialogControlType()) {
    handleToggleActiveState();
  }
};

onUnmounted(() => {
  props.phoneLine.hangup();
  clearInterval(intervalHandle);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isBuildableDialogControlType())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(description).title), 1),
          _createTextVNode(" " + _toDisplayString(timeOnActiveCall.value.minutes) + ":" + _toDisplayString(timeOnActiveCall.value.seconds) + " ", 1),
          _createElementVNode("button", _hoisted_4, [
            _createVNode(IconComponent, {
              icon: _unref(Icon).PHONE_HANGUP_SMALL,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleHangUp()))
            }, null, 8, ["icon"])
          ])
        ]))
      : _createCommentVNode("", true),
    (showConversationHistory())
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_unref(showThinkingMessage))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(playerBrain).brain.value.history, (historyItem, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  (historyItem.message.length > 0 && historyItem.isVisible)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["message", {
              player: isPlayer(historyItem.sender),
              npc: !isPlayer(historyItem.sender)
            }])
                        }, [
                          _createElementVNode("p", _hoisted_10, _toDisplayString(historyItem.message), 1)
                        ], 2)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(control)), {
        brain: _unref(playerBrain).brain.value,
        onSubmit: handleOptionClicked,
        onHangup: _cache[1] || (_cache[1] = ($event: any) => (handleHangUp())),
        timeOnActiveCall: timeOnActiveCall.value
      }, null, 40, ["brain", "timeOnActiveCall"]))
    ])
  ]))
}
}

})